export default __webpack_public_path__ + "static/media/Scott-Newman.859d1346.jpg";